module.exports = __webpack_public_path__ + "img/fiber-invoice.7e6db1b8.png";